import { connect } from 'react-redux';

import { NavLocationSelectors } from '../selectors/NavigationStateSelectors';
import { siteUrlsSelector } from '../selectors/SiteUrlsSelectors';
import { AppState } from '../state/AppState';
import { MapStateToProps } from '../utils/ConnectUtils';
import { PageHeaderMenus, PageHeaderMenusStateProps } from './PageHeaderMenus';


const mapStateToProps: MapStateToProps<PageHeaderMenusStateProps> = (state: AppState): PageHeaderMenusStateProps => ({
  inServerArea: NavLocationSelectors.inServerArea(state),
  inSiteArea: NavLocationSelectors.inSiteArea(state),
  inSiteContentArea: NavLocationSelectors.inSiteContentArea(state),
  siteUrls: siteUrlsSelector(state),
});

export const ConnectedPageHeaderMenus = connect(mapStateToProps)(PageHeaderMenus);
